Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.TikTokPostContentFactory

  create: (socialContent, allTags) ->
    return new Monitoring.Models.SocialContents.TikTokPostContent(socialContent).set({ possibleTags: allTags })

  canHandle: (socialContent) ->
    return socialContent.sub_type == 'tiktok-post'
